import React from "react";

import { FilterIcon as Filter } from "@packages/ds";
import { useIntl } from "react-intl";

import * as Dropdown from "ds/Dropdown";

import * as S from "./HostSelector.styles";

type HostSelectorProp = {
  hosts: string[];
  selected: string[];
  onChange: (selected: string[]) => void;
  filterTitleId?: string;
  prefixHost?: boolean;
};

const HostSelector = ({
  hosts = [],
  selected = [],
  onChange,
  filterTitleId = "filter",
  prefixHost = true
}: HostSelectorProp) => {
  const intl = useIntl();

  return (
    <Dropdown.Root>
      <S.DropdownTrigger variant="mixed">
        {filterTitleId} <Filter />
      </S.DropdownTrigger>
      <Dropdown.Portal>
        <S.DropdownContent>
          {hosts.map(hostName => (
            <Dropdown.CheckboxItem
              key={hostName}
              checked={!!selected.includes(hostName)}
              id={
                hostName === "average"
                  ? "average"
                  : prefixHost
                    ? `host-${hostName}`
                    : hostName
              }
              onCheckedChanged={checked => {
                const updated = !checked
                  ? selected.filter(host => host !== hostName)
                  : [...selected, hostName];
                onChange(updated);
              }}
            >
              {hostName === "average"
                ? intl.formatMessage({ id: "average" })
                : prefixHost
                  ? `${intl.formatMessage({ id: "host" })} ${hostName}`
                  : hostName}
            </Dropdown.CheckboxItem>
          ))}
        </S.DropdownContent>
      </Dropdown.Portal>
    </Dropdown.Root>
  );
};

export default HostSelector;
